import { useCallback } from 'react';
import { captureMediaLoadError } from 'common/modules/media/captureMediaLoadError';

/**
 * onError handler for raw <img> tags that reports the failure to Sentry.
 * Deduplication (once per broken source) lives in captureMediaLoadError, so
 * repeated error events for the same image collapse to a single report.
 *
 * @param context short label for where the image lives (e.g. 'learn-task',
 *                'image-object-task') so failures are groupable in Sentry.
 */
export function useImageErrorHandler(
  context: string
): (event: React.SyntheticEvent<HTMLImageElement, Event>) => void {
  return useCallback(
    (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
      const target = event.currentTarget;
      captureMediaLoadError(new Error('Image failed to load'), {
        kind: 'image',
        src: target?.currentSrc || target?.src,
        context
      });
    },
    [context]
  );
}
